import { Injectable } from '@angular/core';
import { FieldType } from '@sla-ng/ui-material';
import { IPlannedSaleVolumeLayout } from '../../models/layout/planned-sale-volume-layout.model';
import { IPlannedSaleVolumeDialogLayout } from '../../models/layout/planned-sale-volume-dialog-layout.model';
import { SharedDataFacade } from '../facades/master-data/shared-data.facade';

@Injectable({
    providedIn: 'root',
})
export class PlannedSaleVolumeLayoutService {

    constructor(protected mySharedDataFacade: SharedDataFacade) {
    }

    public getPlannedSaleVolumeLayout(): IPlannedSaleVolumeLayout {
        return {
            columns: [ 'articleNr', 'costUnit', 'validFrom', 'validTo', 'amount', 'actions' ],
            filterFields: [
                {
                    type: FieldType.select,
                    label: 'app.page.planned-sale-volume.cost-unit-filter.label',
                    field: 'costUnitId',
                    withClearButton: true,
                    selectData: {
                        options: this.mySharedDataFacade.fetchCostUnits(),
                        valueKey: 'id',
                        separator: ' - ',
                        labelKeys: [ 'articleNr', 'name' ],
                        displaySearch: true,
                    },
                },
                { field: 'dateFilter', type: FieldType.daterange, label: 'app.page.planned-sale-volume.date-filter.label', withClearButton: true },
            ],
        };
    }

    public getUpdateDialogLayout(): IPlannedSaleVolumeDialogLayout {
        return {
            fields: [
                {
                    type: FieldType.select,
                    label: 'app.model.planned-sale-volume.cost-unit.label',
                    field: 'costUnitId',
                    readonly: true,
                    disabled: true,
                    required: false,
                    selectData: {
                        valueKey: 'id',
                        labelKeys: [ 'articleNr', 'name' ],
                        separator: ' - ',
                        displaySearch: true,
                        options: this.mySharedDataFacade.fetchCostUnits(),
                    },
                },
                {
                    type: FieldType.select,
                    label: 'app.model.planned-sale-volume.measure-unit.label',
                    field: 'measureUnitId',
                    withClearButton: false,
                    disabled: true,
                    required: false,
                    selectData: {
                        valueKey: 'id',
                        labelKeys: [ 'name' ],
                        displaySearch: true,
                        options: this.mySharedDataFacade.fetchMeasureUnits(),
                    },
                },
                {
                    type: FieldType.decimal,
                    label: 'app.model.planned-sale-volume.amount.label',
                    field: 'amount',
                    required: true,
                },
                {
                    type: FieldType.daterange,
                    label: 'app.model.planned-sale-volume.daterange.label',
                    field: 'dateRange',
                    required: true,
                },
            ],
        };
    }

    public getAddDialogLayout(): IPlannedSaleVolumeDialogLayout {
        return {
            fields: [
                {
                    type: FieldType.select,
                    label: 'app.model.planned-sale-volume.cost-unit.label',
                    field: 'costUnitId',
                    withClearButton: true,
                    required: true,
                    selectData: {
                        valueKey: 'id',
                        labelKeys: [ 'articleNr', 'name' ],
                        separator: ' - ',
                        displaySearch: true,
                        options: this.mySharedDataFacade.fetchCostUnits(),
                    },

                },
                {
                    type: FieldType.select,
                    label: 'app.model.planned-sale-volume.measure-unit.label',
                    field: 'measureUnitId',
                    withClearButton: false,
                    required: false,
                    disabled: true,
                    selectData: {
                        valueKey: 'id',
                        labelKeys: [ 'name' ],
                        displaySearch: true,
                        options: this.mySharedDataFacade.fetchMeasureUnits(),
                    },
                },
                {
                    type: FieldType.decimal,
                    label: 'app.model.planned-sale-volume.amount.label',
                    field: 'amount',
                    required: true,
                },
                {
                    type: FieldType.daterange,
                    label: 'app.model.planned-sale-volume.daterange.label',
                    field: 'dateRange',
                    required: true,
                },
            ],
        };
    }


}
